import * as React from 'react';

export const customTags: Set<string> = new Set([
  "LOGIN",
  "CONT",
  "LINE",
  "DECOR",
  "INK",
  "BORDER",
  "MESSAGE",
  "EDGE",
  "EDGE_COVER",
  "VIEW",
  "ICON",
  "SEPARATOR",
  "LOGO",
  "INFO",
  "CONTAINER",
  "HORIZONAL_WRAP",
  "CONTENT",
  "CONTENT_WRAP",
  "TEXT_LABEL",
  "TEXT",
  "CHECK",
  "BOX",
  "WRAP",
  "LIST",
  "ITEM",
  "OVERLAY",
  "GRID",
  "SCROLLER",
  "BLOCK",
  "SPACE",
  "PICTURE",
  "DEMOSPACE",
  "NAME",
  "BADGE",
  "GROUP",
  "DASHBOARD",
  "SUBTITLE",
  "SWITCH",
  "SWITCHABLE",
  "PLAYER",
  "PLAYLIST",
  "MEDIA",
  "CIRCLE",
  "LINE",
  "ROW",
  "INFOBAR",
  "THUMB",
  "DETAIL",
  "COVER",
  "CONTROLS",
  "DECOR",
  "DECORATION",
  "DOT",
  "GAP",
  "PIE",
  "TIP",
  "COL",
  "COUNT",
  "TEST",
  "ZONE",
  "LAYOUT",
  "TAG",
  "ACTION",
  "ELASTIC",
  "TOOLBAR",
  "COMMANDBAR",
  "PANEL",
  "WRAPPER",
  "WIDGET",
  "DEMO_WRAP",
  "APPLICATION",
  "THUMBS",
  "POINT",
  "HOLDER",
  "CYCLE",
  "TICK",
  "ALERT",
  "DISTRIBUTION",
  "HAMBURGER",
  "PULSE",
  "SIGNATURE",
  "SLIDER",
  "SLIDE",
  "BACK",
  "ERRORMESSAGE",
  "MATERIAL",
  "INFOMESSAGE",
  "FIELDS",
  "FIELDWRAP",
  "DECORATION",
  "TOOLTIP"
]);

const nativeTostring = Object.prototype.toString;
// toString override added to prototype of Custom class
// eslint-disable-next-line
Object.prototype.toString = function () {
  //NOSONAR
  const tag = this as HTMLElement;
  try {
    if (customTags.has(tag.tagName)) {
      return `[object ${tag.tagName}]`;
    }
    // eslint-disable-next-line no-empty
  } catch {}

  return nativeTostring.call(this);
};

// eslint-disable-next-line no-extend-native
 // @ts-ignore
Number.prototype.round = function(places: number) { // NOSONAR
   // @ts-ignore
  return +(Math.round(this + "e+" + places)  + "e-" + places); // NOSONAR
};

declare module "react/jsx-runtime" {
  namespace JSX {
    interface IntrinsicElements {
      "action": React.HTMLAttributes<HTMLElement>;
      "alert": React.HTMLAttributes<HTMLElement>;
      "application": React.HTMLAttributes<HTMLElement>;
      "badge": React.HTMLAttributes<HTMLElement>;
      "block": React.HTMLAttributes<HTMLElement>;
      "box": React.HTMLAttributes<HTMLElement>;
      "check": React.HTMLAttributes<HTMLElement>;
      "circle": { 
        cx?: string | number;
        cy?: string | number;
        r?: string | number;
        fill?: string;
        strokeWidth?: string;
        strokeLinecap?: string;
      } & React.HTMLAttributes<HTMLElement>;
      "col": React.HTMLAttributes<HTMLElement>;
      "cont": { 
        s?: string | boolean;
      } & React.HTMLAttributes<HTMLElement>;
      "a": any | React.HTMLAttributes<HTMLElement>
      "ink": React.HTMLAttributes<HTMLElement>;
      "border": React.HTMLAttributes<HTMLElement>;
      "container": React.HTMLAttributes<HTMLElement>;
      "content_wrap": React.HTMLAttributes<HTMLElement>;
      "controls": React.HTMLAttributes<HTMLElement>;
      "count": React.HTMLAttributes<HTMLElement>;
      "cover": React.HTMLAttributes<HTMLElement>;
      "cycle": React.HTMLAttributes<HTMLElement>;
      "decor": React.HTMLAttributes<HTMLElement>;
      "demo_wrap": React.HTMLAttributes<HTMLElement>;
      "demospace": React.HTMLAttributes<HTMLElement>;
      "detail": React.HTMLAttributes<HTMLElement>;
      "distribution": React.HTMLAttributes<HTMLElement>;
      "dot": React.HTMLAttributes<HTMLElement>;
      "elastic": React.HTMLAttributes<HTMLElement>;
      "errormessage": React.HTMLAttributes<HTMLElement>;
      "gap": React.HTMLAttributes<HTMLElement>;
      "sidesgap": React.HTMLAttributes<HTMLElement>;
      "grid": React.HTMLAttributes<HTMLElement>;
      "group": { 
        direction?: string;
        ratio?: string;
        gap?: string;
        key?: React.Key | string | undefined | null;
        ref?: React.RefObject<HTMLDivElement | null> | React.Ref<HTMLDivElement> | undefined;
      } & React.HTMLAttributes<HTMLElement>;
      "holder": React.HTMLAttributes<HTMLElement>;
      "horizonal_wrap": React.HTMLAttributes<HTMLElement>;
      "icon": React.HTMLAttributes<HTMLElement>;
      "info": React.HTMLAttributes<HTMLElement>;
      "infobar": React.HTMLAttributes<HTMLElement>;
      "item": React.HTMLAttributes<HTMLElement>;
      "layout": React.HTMLAttributes<HTMLElement>;
      "line": { 
        "x2"?: string;
        transform?: string;
        fill?: string;
        stroke?: string;
      } & React.HTMLAttributes<HTMLElement>;
      "list": React.HTMLAttributes<HTMLElement>;
      "login": React.HTMLAttributes<HTMLElement>;
      "logo": React.HTMLAttributes<HTMLElement>;
      "media": React.HTMLAttributes<HTMLElement>;
      "message": React.HTMLAttributes<HTMLElement>;
      "name": React.HTMLAttributes<HTMLElement>;
      "overlay": React.HTMLAttributes<HTMLElement>;
      "panel": React.HTMLAttributes<HTMLElement>;
      "picture": React.HTMLAttributes<HTMLElement>;
      "pie": React.HTMLAttributes<HTMLElement>;
      "player": React.HTMLAttributes<HTMLElement>;
      "playlist": React.HTMLAttributes<HTMLElement>;
      "point": React.HTMLAttributes<HTMLElement>;
      "pulse": React.HTMLAttributes<HTMLElement>;
      "row": React.HTMLAttributes<HTMLElement>;
      "scroller": React.HTMLAttributes<HTMLElement>;
      "subtitle": React.HTMLAttributes<HTMLElement>;
      "separator": {
        vertical?: string | boolean | undefined;
        horizontal?: string | boolean | undefined;
      } & React.HTMLAttributes<HTMLElement>;
      "space": { 
        horizontal?: string;
      } & React.HTMLAttributes<HTMLElement>;
      "span": React.HTMLAttributes<HTMLElement>;
      "switchable": React.HTMLAttributes<HTMLElement>;
      "tag": React.HTMLAttributes<HTMLElement>;
      "test": React.HTMLAttributes<HTMLElement>;
      "text": { 
        light?: string;
        accent?: string;
      } & React.HTMLAttributes<HTMLElement>;
      "thumb": React.HTMLAttributes<HTMLElement>;
      "thumbs": React.HTMLAttributes<HTMLElement>;
      "tick": React.HTMLAttributes<HTMLElement>;
      "tip": React.HTMLAttributes<HTMLElement>;
      "toolbar": React.HTMLAttributes<HTMLElement>;
      "view": {
        ref?: React.RefObject<any>;
      } & React.HTMLAttributes<HTMLElement>;
      "widget": React.HTMLAttributes<HTMLElement>;
      "wrap": { 
        mini?: string;
        gap?: string;
      } & React.HTMLAttributes<HTMLElement>;
      "wrapper": React.HTMLAttributes<HTMLElement>;
      "zone": React.HTMLAttributes<HTMLElement>;
      "hamburger": React.HTMLAttributes<HTMLElement>;
      "dashboard": React.HTMLAttributes<HTMLElement>;
      "length": React.HTMLAttributes<HTMLElement>;
      "preline": React.HTMLAttributes<HTMLElement>;
      "monospace": React.HTMLAttributes<HTMLElement>;
      "size": React.HTMLAttributes<HTMLElement>;
      "slide": React.HTMLAttributes<HTMLElement>;
      "slider": React.HTMLAttributes<HTMLElement>;
      "material": React.HTMLAttributes<HTMLElement>;
      "infomessage": React.HTMLAttributes<HTMLElement>;
      "fields": React.HTMLAttributes<HTMLElement>;
      "fieldwrap": React.HTMLAttributes<HTMLElement>;
      "decoration": React.HTMLAttributes<HTMLElement>;
      "button": { 
        type?: string;
        ref?: string;
      } & React.HTMLAttributes<HTMLElement>;
      "back": React.HTMLAttributes<HTMLElement>;
      "div": { 
        key?: React.Key | string | undefined | null;
        view?: string;
        effect?: string;
        ref?: React.RefObject<HTMLDivElement | null> | React.ForwardedRef<HTMLDivElement | null> | undefined;
        fixed?: any;
      } & React.HTMLAttributes<HTMLElement>;
      "Tooltip": { 
        space?: boolean;
      } & React.HTMLAttributes<HTMLElement>;
      "input": { 
        ref?: string | React.RefCallback<HTMLElement> | undefined; 
        type?: string; 
        placeholder?: string;
        name?: string;
        value?: any;
        disabled?: boolean;
        readOnly?: boolean;
        radio?: string;
        checked?: boolean | undefined;
       } & React.HTMLAttributes<HTMLElement>;
      "label": { 
        key?: React.Key | string | undefined | null;
        classic?: string;
        checkbox?: string | boolean;
        effect?: string;
        radio?: string
      } & React.HTMLAttributes<HTMLElement>;
      "b": React.HTMLAttributes<HTMLElement>;
      "ul": React.HTMLAttributes<HTMLElement>;
    }
  }
}


declare module "react" {
  interface Attributes {
    // extends React's HTMLAttributes
    autocomplete?: string | boolean;
    dashboard?: string | boolean;
    classic?: string | boolean;
    checkbox?: string | boolean | undefined;
    checkboxProps?: any;
    simple?: string | boolean;
    minimal?: string | boolean;
    radio?: string | boolean;
    effect?: string;
    border?: string;
    link?: string;
    light?: string | boolean;
    wrap?: string | boolean;
    top?: string;
    tiny?: string;
    fixed?: any; //string | boolean;
    small?: string;
    mini?: string | boolean;
    medium?: string | boolean;
    large?: string | boolean;
    horizontal?: string | boolean;
    intro?: string;
    background?: string;
    space?: string | boolean | number;
    launcher?: string | boolean;
    backdrop?: string;
    resize?: string;
    main?: string;
    icon?: string | ReactElement;
    image?: ReactElement;
    index?: string | number | boolean;
    ref?: any;
    options?: any;
    virtual?: any;
    allowSearch?: any;
    loading?: boolean | any;
    ellipsis?: string | boolean;
    view?: any;
    decoration?: string;
    accent?: any;
    accent_text?: any;
    vertical?: boolean;
    inputbox?: string;
    preline?: string;
    monospace?: string;
    type?: string;
    editable?: any;
    length?: any;
    //size?: any;
    middle?: any;
    fit?: any;
    fixlength?: string;
    title?: any;
    direction?: any;
    controls?: any;
    onCustomChange?: (name: string, value: any) => void;
    // gap?: string;
    "data-adaptive"?: "desktop" | "mobile";
    "data-horizontal"?: "" | "dotted";
    "data-margin"?: "none" | "-30" | "-60" | "5" | "10" | "15" | "30" | "40";
    "data-margin-top"?: "-1";
    "data-wrap"?: "" | "no" | "wrap" | "nowrap" | "preline";
    "data-text-align"?: "center" | "right" | "left";
    "data-align"?: "center" | "end" | "start" | "baseline" | "stretch";
    "data-justify"?: "center" | "end" | "start" | "space-around" | "space-between" | "space-evenly";
    "data-position"?: "center" | "right" | "left" | "bottom" | "absolute" | "fixed";
    "data-sticky"?: "" | "top" | "bottom" | "150";
    "data-sticky-level"?: "2" | "10" | "40" | "50" | "60" | "75" | "80" | "90";
    "data-text-size"?: "10" | "12" | "13" | "14" | "15" | "medium" | "17" | "large" | "larger" | "22" | "x-large" | "25" | "xx-large" | "40" | "xxx-large" | "64" | "72" | "96";
    "data-label-size"?: "12";
    "data-weight"?: "100" | "300" | "400" | "500" | "600" | "700" | "800" | "900";
    "data-font-type"?: "mono";
    "data-length"? : "" |"0" | "2" | "5" | "10" | "20" | "30" | "40" | "50" | "60" | "70" | "80" | "90" | "100" | "110" |
        "120" | "130" | "140" | "150" | "160" | "170" | "180" | "190" | "200" | "210" | "220" | "230" | "240" | "250" | "260" | 
        "280" | "300" | "310" | "320" | "330" | "340" | "350" | "360" | "370" | "380" | "390" | "400" | "410" | "430" | "450" | 
        "480" | "500" | "600" | "700" | "610" | "autofit" | "auto" | "forcefit";
    "data-max-length"?: "auto" | "fit" | "40" | "100" | "180" | "200" | "250" | "300" | "350" | "400" | "460" | "500" | "480" |
        "600" | "700" | "800" | "1200" | "1600" | "1440";
    "data-min-length"?: "10" | "80" | "120" | "140" | "160" | "180" | "200" | "240" | "300" | "400" | "fit";
    "data-fit"?: "" | "1" | "1.5" | "2" | "2.5" | "3" | "3.5" | "4";
    "data-contain"?: "" | "visible";
    "data-text-nowrap"?: "";
    "data-text-line"?: "1.5" | "1.3";
    "data-shrink"?: "no" | "yes";
    "data-uppercase"?: "";
    "data-headline"?: "";
    "data-link"?: "" | "normal" | "colorize";
    "data-text-direction"?: "ltr";
    "data-direction"?: "column" | "row";
    "data-react"?: "scale";
    "data-object-fit"?: "contain" | "cover";
    "data-ratio"?: "" | "1:1" | "16:9" | "5:4" | "4:3" | "2:1";
    "data-height"?: "1" | "5" | "10" | "15" | "20" | "24" | "28" | "30" | "36" | "40" | "48" | "50" | "54" |
        "58" | "60" | "70" | "80" | "90" | "100" | "120" | "160" | "210" | "250" | "300" | "350" | 
        "fit" | "auto" | "autofit";
    "data-margin-vertical"?: "5" | "10";
    "data-max-height"?: "fit" | "10" | "30" | "40" | "50" | "72" | "130" | "200" | "300" | "400";
    "data-space"?: "1" | "2" | "3" | "4" | "5" | "7" | "8" | "9" | "10" | "15" | "20" | "25" | "30" | "40" | "50" | "80";
    "data-space-horizontal"?: "5" | "7" | "10" | "12" | "15" | "16" | "20" | "30" | "40" | "50";
    "data-space-vertical"?: "2" | "5" | "8" | "10" | "15" | "20" | "24" | "30" | "40" | "50";
    "data-space-left"?: "5" | "10" | "15" | "20" | "30" | "40" | "200";
    "data-space-right"?: "5" | "10" | "15" | "20";
    "data-space-bottom"?: "5" | "10" | "20" | "50" | "150";
    "data-space-top"?: "0" | "5" | "10" | "20";
    "data-gap"?: "1" | "3" | "4" | "5" | "8" | "10" | "12" | "15" | "20" | "24" | "30" | "40" | "50" | "100" | "none";
    "data-border"?: "" | "overprint" | "outline" | "inset" | "no" | "2" | "inheret" | "dashed";
    "data-border-color"?: "main-color" | "border-color" | "success-color";
    "data-border-left"?: "";
    "data-border-right"?: "";
    "data-border-top"?: "";
    "data-border-bottom"?: "";
    "data-border-vertical"?: "1";
    "data-radius"?: "0" | "3" | "5" | "4" | "7" | "8" | "10" | "15" | "20" | "25" | "30" | "40" | "less-special" | "special" | "extra-special";
    "data-radius-top"?: "10";
    "data-radius-bottom"?: "10";
    "data-radius-bottom-left"?: "0";
    "data-radius-top-left"?: "0";
    "data-radius-bottom-right"?: "0";
    "data-background"?: "info" | "checkered" | "main-color-custom-lighter" | "main-color-custom-light" | "accent-xtralight" | "accent-semilight" |
        "accent-light" | "main" | "accent-dark" | "accent-darker" | "grey-color-dark" | "grey-color-mid" | "grey-color-light" | "grey-color-semilight" |
        "grey-color-xtralight" | "error-color" | "border-color" | "success-color" | "success-color-light" | "warning" | "warning-light" | 
        "success-color-dark" | "warning-dark" |
        "main-lighter" | "main-light" | "main-dark" | "main-darker" | "secondary-lighter" | "secondary-light" | "secondary" |
        "secondary-dark" | "secondary-darker" | "main-background" | "highlight" | "border-color" | "context" | "white" | "black" | "graph" |
        "dashed" | "stripe" | "linear-dark-bottom" | "linear-middark-bottom" | "red" | "pink" | "purple" | "deep-purple" | "indigo" |
        "blue" | "light-blue" | "cyan" | "teal" | "green" | "light-green" | "lime" | "yellow" | "amber" | "orange" | "deep-orange" | 
        "brown" | "grey" | "none" | "error" | "success" | "site";
    "data-color"?: "accent-xtralight" | "accent-semilight" | "accent-light" | "main" | "accent-dark" | "accent-darker" | "grey-color-dark" |
        "grey-color-mid" | "grey-color-light" | "grey-color-semilight" | "grey-color-xtralight" | "error-color" | "border-color" | "success-color" |
        "success-color-light" | "warning" | "warning-light" | "success-color-dark" | "warning-dark" | "red" | "pink" | "purple" | "deep-purple" | 
        "indigo" | "blue" | "light-blue" | "cyan" | "teal" | "green" | "light-green" | "lime" | "yellow" | "amber" | "orange" | "deep-orange" |
        "brown" | "grey" | "blue-grey" | "text" | "white" | "black" | "error" | "success" | "secondary";
    "data-width"?: "auto";
    "data-svg-color"?: "main-lighter" | "main-light" | "main" | "main-dark" | "main-darker" | "white" | "accent-xtralight" | "accent-semilight" |
        "accent-light" | "main" | "accent-dark" | "accent-darker" | "grey-color-dark" | "grey-color-mid" | "grey-color-light" | "grey-color-semilight" |
        "grey-color-xtralight" | "error-color" | "border-color" | "success-color" | "success-color-light" | "warning" | "warning-light" |
        "success-color-dark" | "warning-dark" | "secondary";
    "data-icon-size"?: "10" | "16" | "small" | "24" | "30" | "48" | "mini" | "medium" | "large" | "x-large" | "x-large";
    "data-svg-size"?: "" | "fit" | "16" | "24" | "32" | "48x" | "20" | "30" | "40" | "50" | "100";
    
  }
}

